import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./store/auth";
import { MetaProvider } from "./store/meta";
import { ToastProvider } from "./store/toast";
import { NotificationProvider } from "./store/notifications";
import { I18nProvider } from "./i18n";
import { UpdateProvider } from "./store/updateCheck";
import UpdateBanner from "./components/UpdateBanner";
import { aplicarApariencia } from "./store/appearance";
import "./index.css";

// Aplica la fuente y el tamaño elegidos por el usuario antes de renderizar
// (evita el parpadeo de cambiar después de pintar).
aplicarApariencia();

// Si llegamos hasta aquí, el bundle actual (index.html + chunk principal)
// cargó bien — limpia la marca que evita el loop de recargas por chunk viejo
// (ver ErrorBoundary.jsx).
sessionStorage.removeItem("tf-chunk-reload");

// Vite emite este evento cuando un import() dinámico falla (chunk borrado por
// un deploy nuevo mientras la pestaña seguía con el bundle viejo abierta).
// Es la misma situación que cubre ErrorBoundary, pero este evento dispara
// ANTES de que React llegue a lanzar el error — cubre más casos.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  if (!sessionStorage.getItem("tf-chunk-reload")) {
    sessionStorage.setItem("tf-chunk-reload", "1");
    window.location.reload();
  }
});

// Favicon de la instancia (branding público: funciona también en el login).
fetch("/api/v1/config/branding")
  .then((r) => (r.ok ? r.json() : null))
  .then((b) => {
    if (b?.favicon_path) {
      const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = `/uploads/${b.favicon_path}`;
      document.head.appendChild(link);
    }
  })
  .catch(() => {});

// El service worker se eliminó por completo (causaba pantallas en blanco al
// interceptar los assets con un SW viejo/roto cacheado). Ya NO registramos uno;
// además desmontamos cualquier registro/cache que haya quedado de versiones
// previas. Nota: si el SW viejo bloquea este bundle, esto no llega a correr —
// por eso la recuperación real la hace el sw.js autodestructivo, que el
// navegador actualiza por su cuenta al navegar.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <UpdateProvider>
      <UpdateBanner />
      <BrowserRouter>
        <AuthProvider>
          <I18nProvider>
            <MetaProvider>
              <ToastProvider>
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </ToastProvider>
            </MetaProvider>
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </UpdateProvider>
  </React.StrictMode>
);
